import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;


export const getApplication = createAsyncThunk(
  "application/getApplication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/application/getApplication",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  application: [],
};

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApplication.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.application = action.payload.result.list;
      })
      .addCase(getApplication.rejected, (state, action) => {
        state.loading = false;
      })
  },
});


export default applicationSlice.reducer;